export class ShipmentReference {
    shipmentReference: any; 
    ShipmentReferenceType: any;  
}